import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { GoVerified } from "react-icons/go";
import { HiOutlineHome } from 'react-icons/hi2';
import { IsMobileEnv } from '../../configurations/initUrls';
import useAuth from '../../configurations/auth/publicUsers/useAuth';
import QRScanner from '../../configurations/native/QRScanner';
import { MdOutlineFormatListBulleted } from 'react-icons/md';
import { CgUserList } from 'react-icons/cg';
import { VscCoverage } from 'react-icons/vsc';
import { BsThreeDots } from 'react-icons/bs';
import { GrFavorite } from 'react-icons/gr';

const FabToggleMobile = () => {
    const { authentication } = useAuth();
    const location = useLocation();
    const [checkOpen, setCheckOpen] = useState(false);
    const containerRef = useRef(null);

    // bahar tap/click karne par popup band karo
    useEffect(() => {
        if (!checkOpen) return;

        const handleOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setCheckOpen(false);
            }
        };

        document.addEventListener('mousedown', handleOutside);
        document.addEventListener('touchstart', handleOutside);
        return () => {
            document.removeEventListener('mousedown', handleOutside);
            document.removeEventListener('touchstart', handleOutside);
        };
    }, [checkOpen]);

    const items = [
        { to: '/', icon: <HiOutlineHome size={20} />, label: 'Home', color: 'text-indigo-600' },
        ...(IsMobileEnv && authentication.isLogin
            ? [
                { to: '/myregister', icon: <CgUserList size={20} />, label: 'Reg', color: 'text-purple-600' },
                { to: '/myconfirmed', icon: <VscCoverage size={20} />, label: 'Conf', color: 'text-teal-600' },
            ]
            : []),
        { to: '/favorite', icon: <GrFavorite className="text-red-500" size={20} />, label: 'Doctors', color: 'text-rose-600' },
    ];

    // Check ke andar khulne wale 2 options
    const checkSubItems = [
        { to: '/checkregister', icon: <MdOutlineFormatListBulleted size={20} />, label: 'Check registered', color: 'text-green-600' },
        { to: '/checkconfirmed', icon: <GoVerified size={20} />, label: 'Check Confirmed', color: 'text-blue-600' },
    ];

    // agar sub-route active hai to Check bhi highlighted dikhe
    const checkActive = checkSubItems.some((s) => s.to === location.pathname);

    return (
        <div ref={containerRef} className="w-full px-1.5 fixed bottom-4 left-1/2 -translate-x-1/2 z-50">
            <div className="relative w-full flex items-center justify-between rounded-[32px] bg-white/40 backdrop-blur-md border border-gray-700/20 shadow-xl p-1 z-50">

                {items.map((item) => {
                    const active = location.pathname === item.to;

                    return (
                        <Link key={item.to} to={item.to} className="flex-1 flex justify-center min-w-0">
                            <div
                                className={`
                                    flex flex-col items-center justify-center
                                    w-full min-w-0 px-1 py-2 rounded-[28px]
                                    transition-all duration-300
                                    ${active ? 'bg-black/10 scale-105' : 'hover:bg-black/5'}
                                `}
                            >
                                <div className={active ? item.color : "text-slate-900"}>
                                    {item.icon}
                                </div>
                                <span className={`text-[10px] leading-tight font-medium mt-1 truncate max-w-full ${active ? item.color : 'text-slate-800'}`}>
                                    {item.label}
                                </span>
                            </div>
                        </Link>
                    );
                })}
                <QRScanner />

                <div className="shrink-0 flex justify-center relative">
                    {checkOpen && (
                        <div className="absolute bottom-full mb-6 right-0 pe-1 flex flex-col items-end gap-2 z-50 animate-[fadeIn_0.2s_ease-out]">
                            {checkSubItems.map((sub) => {
                                const subActive = location.pathname === sub.to;

                                return (
                                    <Link
                                        key={sub.to}
                                        to={sub.to}
                                        onClick={() => setCheckOpen(false)}
                                        className={`
                                            flex items-center gap-2 whitespace-nowrap
                                            px-4 py-2.5 rounded-2xl border shadow-lg
                                            bg-white/90 backdrop-blur-md
                                            transition-all duration-200
                                            ${subActive ? 'border-black/20 scale-[1.02]' : 'border-gray-200 hover:bg-white'}
                                        `}
                                    >
                                        <span className={subActive ? sub.color : 'text-slate-900'}>
                                            {sub.icon}
                                        </span>
                                        <span className={`text-[13px] font-medium ${subActive ? sub.color : 'text-slate-800'}`}>
                                            {sub.label}
                                        </span>
                                    </Link>
                                );
                            })}
                        </div>
                    )}

                    <button
                        type="button"
                        onClick={() => setCheckOpen((p) => !p)}
                        className={`
                            flex items-center justify-center
                            w-10 h-10 rounded-full
                            transition-all duration-300
                            ${checkOpen || checkActive ? 'bg-black/10 scale-105' : 'hover:bg-black/5'}
                        `}
                        aria-label="More"
                    >
                        <div className={checkOpen || checkActive ? 'text-orange-600' : 'text-slate-900'}>
                            <BsThreeDots size={22} />
                        </div>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FabToggleMobile;